module.exports = __webpack_public_path__ + "img/礼物-3.6e139f37.png";